import { Button } from "@material-ui/core";
// import { ActionHeader } from '.';
import en from "../../lang/en-us";
const { dashboard } = en;

export default function SuccessScreen({
  heading = "",
  infospan2 = "",
  successMessage = "",
  note = "",
  info3 = "",
  list = [] as any,
  handleClick = () => {},
  backNavigation = () => {},
  showTrackStatusButton = true,
  ...props
}: any) {
  return (
    <>
      <div className="curved-bg-content nct-success-screen">
        <div className="curved-bg-content-inner">
          <div className="curved-bg-content-inner-top">
            <h3 className="subheading">{dashboard.Success.subHeading}</h3>
            <p>
              {successMessage || props.location?.state?.successMessage}
            </p>
            <p style={{ fontSize: "16px" }}>{note}</p>
          </div>
          <div className="curved-bg-content-inner-bottom">
            <Button className="customBtn" onClick={handleClick}>
              {dashboard.changeEmail.Success.back}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
